export function isScrollable(node) {
    const style = window.getComputedStyle(node);
    return /(auto|scroll)/.test(style.overflow + style.overflowX + style.overflowY);
}
export function getScrollParent(node) {
    let currentNode = node;
    if (isScrollable(currentNode)) {
        currentNode = currentNode.parentElement;
    }
    while(currentNode && !isScrollable(currentNode)){
        currentNode = currentNode.parentElement;
    }
    return currentNode || document.scrollingElement || document.documentElement;
}

//# sourceMappingURL=getScrollParent.js.map